module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div name=\"form-content\" class=\"wh100 content\">\n    <div class=\"top\">\n        <h2>\n            ")
    ; __append(escapeFn( widget.title ))
    ; __append("\n        </h2>\n        <div class='form-body'>\n            ")
    ; __append( UI.Template.render(widget.itemTemplate, locals) )
    ; __append("\n        </div>\n    </div>\n    <div class=\"footer\">\n        <div name=\"back\" class=\"button\" on-click=\"onBackClick\">Назад</div>\n        <div name=\"save\" class=\"button\" on-click=\"onSaveClick\">Сохранить</div>\n    </div>\n</div>\n")
  }
  return __output.join("");

}